import React from 'react';
import PropTypes from 'prop-types';
import { cloneObject } from '../../../common/utils';

const ButtonElement = React.forwardRef((props, ref) => {
  const { children } = props;
  const elementAttributes = cloneObject(props, {}, ['to', 'isLinkExternal', 'children']);
  return <button ref={ref} {...elementAttributes}>{children}</button>;
});

ButtonElement.propTypes = {
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(['submit', 'button']),
  appearance: PropTypes.oneOf(['submit', 'button']),
  onClick(props, propName, componentName) {
    if (props.type === 'button' && !props[propName]) {
      return new Error(`Error: "onClick" property is required if the element type is "button" - in ${componentName}`);
    }
  }
};

export default ButtonElement;